<template>
  <ContentWrap>
    <el-form inline>
      <el-form-item label="酒店">
        <el-select v-model="shopId" clearable filterable class="!w-240px" placeholder="请选择酒店">
          <el-option v-for="item in hotels" :key="item.id" :label="item.name" :value="item.id" />
        </el-select>
      </el-form-item>
      <el-button type="primary" @click="load"
        ><Icon icon="ep:search" class="mr-5px" />查询</el-button
      >
    </el-form>
  </ContentWrap>
  <ContentWrap>
    <el-alert
      class="mb-16px"
      type="info"
      :closable="false"
      title="平台仅查看渠道绑定状态，不展示 AppSecret；绑定和解绑请由酒店经营台完成。"
    />
    <el-empty v-if="!loading && rows.length === 0" description="暂无渠道绑定记录" />
    <el-table v-else v-loading="loading" :data="rows">
      <el-table-column prop="shop_id" label="酒店 ID" width="110" />
      <el-table-column prop="channel_type" label="渠道" min-width="120" />
      <el-table-column prop="app_id" label="AppID" min-width="180" />
      <el-table-column prop="status" label="状态" width="100" />
      <el-table-column prop="bound_at" label="绑定时间" width="180" />
      <el-table-column prop="revoked_at" label="解绑时间" width="180" />
    </el-table>
  </ContentWrap>
</template>

<script setup lang="ts">
import { onMounted, ref } from 'vue'
import { getAllHotelShopSimpleList, type HotelPlatformShopOption } from '@/api/hotel/platformShop'
import { getPlatformChannels } from '@/api/hotel/management'

defineOptions({ name: 'HotelPlatformChannel' })

const loading = ref(false)
const rows = ref<any[]>([])
const hotels = ref<HotelPlatformShopOption[]>([])
const shopId = ref<string | number>()

async function load() {
  loading.value = true
  try {
    rows.value = (await getPlatformChannels({ shopId: shopId.value })) || []
  } finally {
    loading.value = false
  }
}

onMounted(async () => {
  hotels.value = (await getAllHotelShopSimpleList()) || []
  await load()
})
</script>
